import { useSelector, useDispatch } from 'react-redux';
import { useLayoutEffect } from 'react';
import { isCustomerGuest } from '../../../../helpers/customer';
import { getIsGuest, getIsInitial, setIsGuest } from './customer';

export const useCustomer = () => {
    const dispatch = useDispatch();
    const isGuest = useSelector(getIsGuest);
    const isInitial = useSelector(getIsInitial);

    useLayoutEffect(() => {
        if (isInitial) {
            const status = isCustomerGuest();
            dispatch(setIsGuest(status));
        }
    }, []);

    return isGuest;
};
